// Typelizer digest d9c5b353a7f318140eed9bd49a5b92d6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/documents/review_queue */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/documents/review_queue', {}, options),
    method: 'get',
  }),
}
